import React, {useEffect, useState} from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import './ReportStyles.css';
import axios from "axios"; // Importa el archivo CSS

const PowerbiOperaciones = () => {
    const [embedConfig, setEmbedConfig] = useState(null); // Estado para la configuración del embed
    const [loading, setLoading] = useState(true); // Estado para mostrar un indicador de carga

    useEffect(() => {
        axios.post('https://quickview.rskgroupco.com/app/powerbi/operaciones')
            .then(response => {
                const { report_id, embed_url, access_token } = response.data; // Asume que la respuesta contiene report_id y access_token
                setEmbedConfig({
                    reportId: report_id,
                    embedUrl: embed_url,
                    accessToken: access_token
                });
                setLoading(false);
                console.log("success")
            })
            .catch(error => {
                console.error('Error al obtener los datos del reporte:', error);
                setLoading(false); // Ocultar el indicador de carga aunque falle
            });
    }, []);

    return (
        <>
            {loading ? (
                <div className="loading-indicator">Loading...</div> // Indicador de carga
            ) : (
                embedConfig && (
                    <PowerBIEmbed
                        embedConfig={{
                            type: 'report', // Tipo de embed (reporte, dashboard, etc.)
                            id: embedConfig.reportId, // ID del informe en Power BI
                            embedUrl: embedConfig.embedUrl, // URL de incrustación del informe
                            accessToken: embedConfig.accessToken, // Token de acceso de Power BI
                            tokenType: models.TokenType.Embed,
                            settings: {
                                panes: {
                                    filters: {
                                        visible: false
                                    },
                                    pageNavigation: {
                                        visible: true
                                    }
                                },
                                bars: {
                                    statusBar: {
                                        visible: true
                                    }
                                },
                                //layoutType: models.LayoutType.MobileLandscape,
                                background: models.BackgroundType.Transparent,
                            }
                        }}
                        cssClassName="report-style-class" // Clases CSS personalizadas
                        pageView="fitToWidth"
                        onLoad={() => {
                            console.log('El informe se cargó correctamente.');
                        }}
                        onError={(error) => {
                            console.error('Error al cargar el informe:', error);
                        }}
                    />
                )
            )}
        </>
    );
}

export default PowerbiOperaciones